import { createContext } from 'react';

const AppContext = createContext({
    rulesList: [],
    connections: [],
    integrations: [],
    isAdmin: false,
    isReadOnly: false,
    profileEnabled: true,
});

export default AppContext;